import { registerExceptionInTrackingSystem } from './errors';

export const localStorageAvailability = {
  isAvailable: (options?: { registerExceptionInTrackingSystem: boolean }) => {
    try {
      localStorage.getItem('checkLocalStorageAvailability');
      return true;
    } catch (error) {
      if (options?.registerExceptionInTrackingSystem) {
        registerExceptionInTrackingSystem('Failed to get access to localStorage.', error);
      }
      return false;
    }
  },
};
